module.exports = __webpack_public_path__ + "static/media/bulkPower.97fd1bb6.svg";